/**
 * 日志脱敏（上传与本地落盘共用）
 */

/**
 * Error 对象默认 JSON.stringify 会得到 "{}"，导致上报里只有空对象、无法定位问题。
 * 这里把 Error（以及跨 realm 的 error-like 对象）展开成 name/message/stack。
 */
function expandErrors(value, depth = 0) {
  if (value == null || depth > 4) {
    return value;
  }

  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack,
      ...(value.cause != null ? { cause: expandErrors(value.cause, depth + 1) } : {}),
    };
  }

  if (Array.isArray(value)) {
    return value.map((item) => expandErrors(item, depth + 1));
  }

  if (typeof value === 'object') {
    // DOMException 等不是 Error 子类，但同样带 message
    if (typeof value.message === 'string' && typeof value.name === 'string' && !value.__plain) {
      const looksLikeError = typeof value.stack === 'string'
        || value.name.endsWith('Error')
        || value.name === 'DOMException';
      if (looksLikeError) {
        return {
          name: value.name,
          message: value.message,
          stack: value.stack,
        };
      }
    }
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, expandErrors(item, depth + 1)]),
    );
  }

  return value;
}

export function sanitizeLogValue(value) {
  if (value == null) {
    return value;
  }

  if (typeof value === 'string') {
    return value
      .replace(/Bearer\s+[A-Za-z0-9\-._~+/]+=*/gi, 'Bearer [REDACTED]')
      .replace(/("accessToken"\s*:\s*")([^"]+)(")/gi, '$1[REDACTED]$3')
      .replace(/("refreshToken"\s*:\s*")([^"]+)(")/gi, '$1[REDACTED]$3')
      .replace(/token=[^&\s]+/gi, 'token=[REDACTED]');
  }

  if (Array.isArray(value)) {
    return value.map((item) => sanitizeLogValue(item));
  }

  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => {
        if (/token|password|secret|authorization/i.test(key)) {
          return [key, '[REDACTED]'];
        }
        return [key, sanitizeLogValue(item)];
      }),
    );
  }

  return value;
}

export function serializeLogData(data) {
  if (data === undefined) {
    return '';
  }
  if (typeof data === 'string') {
    return sanitizeLogValue(data);
  }
  try {
    return JSON.stringify(sanitizeLogValue(expandErrors(data)));
  } catch (error) {
    return String(data);
  }
}
